import { CloseOutlined } from "@ant-design/icons";
import React from "react";
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { MSGOK, MSGERROR, obtenerUsuario, diaPorNumero, nuevoFormatoFechaCliente, traducirPagina, generateUUID, descargarDocPasandoBase64Doc } from '../../librerias/funciones'
import { SetSertecMarketingSociosEnAPI } from "../../action/actionCreatorsRequests";


import {
    SaveOutlined,
    CloudDownloadOutlined,
    DeleteOutlined,
    PlusOutlined

} from '@ant-design/icons';

import { Card, Input, Row, Col, Drawer, Tabs, Checkbox } from 'antd';
const { TabPane } = Tabs;

const FichaMarketing = (props) => {
    const [hayRegistros, setHayRegistros] = React.useState(false);
    const [tabPorDefecto, setTabPorDefecto] = React.useState("1");
    const [filtroFechas, setFiltroFechas] = React.useState({
        FECHA: true,
        POR_DIA: false,
        INTERVALO: false,

        IR_ENLACE: true,
        ADJUNTAR_DOCUMENTO: false,
        BUSCAR_REFERENCIA: false,

        CAMBIO_IMAGEN: false,
        CAMBIO_DOCUMENTO: false
    });


    const [DIA_REPETICION, setDIA_REPETICION] = React.useState([
        1,
        2,
        3,
        4,
        5,
        6,
        7,
    ]);

    const [payLoadLocal, setPayLoadLocal] = React.useState(
        {
            ID: null,
            ID_SOCIO: 0,
            NOMBRE: "",
            NOMBRE_ALTERNATIVO: "",
            REPETICION: false,
            DIA_REPETICION: 1,
            FECHA_UNICA: "",
            OBSERVACIONES: "",
            DESSE: "",
            HASTA: "",
            ENLACE: "",
            ORDEN: 1,
            REFERENCIA: "",
            TIPO_ACCION_CLICK: 0

        }
    )




    const gestionarFicheroLocal = (input) => {
        const url = input.value;
        const ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase();

        if (input.files && input.files[0]) {
            // if (input.files[0].size <= parseInt(VALOR)) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const base64String = e.target.result
                    .replace('data:', '')
                    .replace(/^.+,/, '');

                ficheroLocal.IMAGEN_NOMBRE = input.files[0].name
                ficheroLocal.DATOS_IMAGEN = base64String
                ficheroLocal.IMAGEN_ORIGINAL = e.target.result
                filtroFechas.CAMBIO_IMAGEN = true


                setFicherosLocal({ ...ficheroLocal });
                setFiltroFechas({ ...filtroFechas })

                //setArchivosLocal([...archivosLocal, registro])

                input.value = '';
            }
            reader.readAsDataURL(input.files[0]);
        } else {
            MSGERROR(traducirPagina("Archivo_no_permitido"), "botton-right")
            input.value = '';
        }
    }



    const gestionarDocumentoLocal = (input) => {
        const url = input.value;
        const ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase();

        if (input.files && input.files[0]) {
            // if (input.files[0].size <= parseInt(VALOR)) {
            const reader = new FileReader();
            reader.onload = (e) => {
                //generateUUID()
                const base64String = e.target.result
                    .replace('data:', '')
                    .replace(/^.+,/, '');

                ficheroLocal.NOMBRE_DOCUMENTO = input.files[0].name
                ficheroLocal.DATOS_DOCUMENTO = base64String
                ficheroLocal.DOCUMENTO_ORIGINAL = e.target.result
                filtroFechas.CAMBIO_DOCUMENTO = true


                setFicherosLocal({ ...ficheroLocal });
                setFiltroFechas({ ...filtroFechas })
                input.value = '';
            }
            reader.readAsDataURL(input.files[0]);
        } else {
            MSGERROR(traducirPagina("Archivo_no_permitido"), "botton-right")
            input.value = '';
        }
    }




    const [ficheroLocal, setFicherosLocal] = React.useState({
        IMAGEN_NOMBRE: "",
        DATOS_IMAGEN: "",
        IMAGEN_ORIGINAL: "",

        NOMBRE_DOCUMENTO: "",
        DATOS_DOCUMENTO: "",
        DOCUMENTO_ORIGINAL: ""
    });



    const guardarEstadoFormulario = (e) => {

        const ID = e.target.name === 'ID' ? e.target.value : payLoadLocal.ID;
        const ID_SOCIO = e.target.name === 'ID_SOCIO' ? e.target.value : payLoadLocal.ID_SOCIO;
        const NOMBRE = e.target.name === 'NOMBRE' ? e.target.value : payLoadLocal.NOMBRE;
        const NOMBRE_ALTERNATIVO = e.target.name === 'NOMBRE_ALTERNATIVO' ? e.target.value : payLoadLocal.NOMBRE_ALTERNATIVO;
        const REPETICION = e.target.name === 'REPETICION' ? e.target.checked : payLoadLocal.REPETICION;
        const DIA_REPETICION = e.target.name === 'DIA_REPETICION' ? e.target.value : payLoadLocal.DIA_REPETICION;
        const FECHA_UNICA = e.target.name === 'FECHA_UNICA' ? e.target.value : payLoadLocal.FECHA_UNICA;
        const OBSERVACIONES = e.target.name === 'OBSERVACIONES' ? e.target.value : payLoadLocal.OBSERVACIONES;

        const DESDE = e.target.name === 'DESDE' ? e.target.value : payLoadLocal.DESDE;
        const HASTA = e.target.name === 'HASTA' ? e.target.value : payLoadLocal.HASTA;


        const ENLACE = e.target.name === 'ENLACE' ? e.target.value : payLoadLocal.ENLACE;
        // const DOCUMENTO = e.target.name === 'DOCUMENTO' ? e.target.files : payLoadLocal.DOCUMENTO;
        const ORDEN = e.target.name === 'ORDEN' ? e.target.value : payLoadLocal.ORDEN;
        const REFERENCIA = e.target.name === 'REFERENCIA' ? e.target.value : payLoadLocal.REFERENCIA;



        payLoadLocal.ID = ID
        payLoadLocal.ID_SOCIO = ID_SOCIO
        payLoadLocal.NOMBRE = NOMBRE
        payLoadLocal.NOMBRE_ALTERNATIVO = NOMBRE_ALTERNATIVO
        payLoadLocal.REPETICION = REPETICION
        payLoadLocal.DIA_REPETICION = DIA_REPETICION
        payLoadLocal.FECHA_UNICA = FECHA_UNICA
        payLoadLocal.OBSERVACIONES = OBSERVACIONES
        payLoadLocal.DESDE = DESDE
        payLoadLocal.HASTA = HASTA
        payLoadLocal.ENLACE = ENLACE
        payLoadLocal.ORDEN = ORDEN
        payLoadLocal.REFERENCIA = REFERENCIA

        setPayLoadLocal({ ...payLoadLocal })
    }


    

    const guardarCambios = () => {
        payLoadLocal.ID_SOCIO = props.ID_SOCIO
        let accion = Object.keys(props.SELECCIONADO).length > 0 ? 1 : 0;


        let PAYLOAD_FINAL = {

            ID: payLoadLocal.ID,
            ID_SOCIO: props.ID_SOCIO,
            NOMBRE: payLoadLocal.NOMBRE,
            NOMBRE_ALTERNATIVO: payLoadLocal.NOMBRE_ALTERNATIVO,

            DIA_FECHA_UNICA: filtroFechas.FECHA,
            FECHA_UNICA: filtroFechas.FECHA ? payLoadLocal.FECHA_UNICA : null,

            REPETICION: filtroFechas.POR_DIA,
            DIA_REPETICION: filtroFechas.POR_DIA ? payLoadLocal.DIA_REPETICION : null,


            ENTRE_DOS_FECHAS: filtroFechas.INTERVALO,

            FECHA_DESDE: filtroFechas.INTERVALO ? payLoadLocal.DESDE : null,
            FECHA_HASTA: filtroFechas.INTERVALO ? payLoadLocal.HASTA : null,

            OBSERVACIONES: payLoadLocal.OBSERVACIONES,


            IMAGEN: ficheroLocal.DATOS_IMAGEN,
            IMAGEN_NOMBRE: ficheroLocal.IMAGEN_NOMBRE,

            DOCUMENTO: ficheroLocal.DATOS_DOCUMENTO,
            DOCUMENTO_NOMBRE: ficheroLocal.NOMBRE_DOCUMENTO,

            URL: payLoadLocal.ENLACE,
            ORDEN: payLoadLocal.ORDEN,

            REFERENCIA:payLoadLocal.REFERENCIA,
            TIPO_ACCION_CLICK:payLoadLocal.TIPO_ACCION_CLICK

        }




        if (accion === 0) {
            if (PAYLOAD_FINAL.IMAGEN !== "") {
                SetSertecMarketingSociosEnAPI(accion, PAYLOAD_FINAL).then(usuario => {
                    if (usuario !== undefined) {
                        if (usuario.OK) {
                            MSGOK(traducirPagina("Msg_anuncio_creado"))

                            props.ACTUALIZAR_REGLAS(1, "A", payLoadLocal.ID_SOCIO, "", "")
                            props.CERRAR_FICHA(false);

                        }
                    }
                })
            } else {
                MSGERROR(traducirPagina("Msg_seleccionar_imagen"))
            }
        } else if (accion === 1) {
            if (!filtroFechas.CAMBIO_IMAGEN) {
                PAYLOAD_FINAL.IMAGEN = null
                PAYLOAD_FINAL.IMAGEN_NOMBRE = null
            }

            if (!filtroFechas.CAMBIO_DOCUMENTO) {
                PAYLOAD_FINAL.DOCUMENTO = null
                PAYLOAD_FINAL.DOCUMENTO_NOMBRE = null
            }

            SetSertecMarketingSociosEnAPI(accion, PAYLOAD_FINAL).then(usuario => {
                if (usuario !== undefined) {
                    if (usuario.OK) {
                        MSGOK(traducirPagina("Msg_modificar_anuncio"))

                        props.ACTUALIZAR_REGLAS(1, "A", payLoadLocal.ID_SOCIO, "", "")
                        props.CERRAR_FICHA(false);

                    }
                }
            })
        }
    }




    return (
        <Drawer
            width={800}
            onClose={() => { props.CERRAR_FICHA(false) }}
            visible={props.ABRIR_FICHA}
            placement={"right"}
            closable={false}
            bodyStyle={{ padding: '0px' }}
            style={{ zIndex: '999', color: '#fff' }}>

            <div className='containerHeaderDrawer'>
                <div className='itemHeaderDrawer1'>
                    <CloseOutlined onClick={(e) => { props.CERRAR_FICHA(false) }}></CloseOutlined>
                    <div> {props.title}</div>
                </div>
            </div>


            <Tabs defaultActiveKey={"1"} activeKey={tabPorDefecto} onChange={(tab) => setTabPorDefecto(tab)} >

                <TabPane tab={traducirPagina("Anuncio")} key="1" className="altura_container_licencias mt-2">
                    <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000' }} >
                        <Col md={24}>
                            <span >{traducirPagina("Orden")} </span>

                            <br></br>
                            <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Msg_Orden")}</span>
                        </Col>

                        <Col md={24}>
                            <Input name="ORDEN" autoComplete="off" value={payLoadLocal.ORDEN} onChange={(e) => guardarEstadoFormulario(e)} />
                        </Col>

                        <Col md={24}>
                            <span>{traducirPagina("Nombre")} </span>
                            <br></br>
                            <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Msg_Identificador_anuncio")}</span>
                        </Col>

                        <Col md={24}>
                            <Input name="NOMBRE" autoComplete="off" value={payLoadLocal.NOMBRE} onChange={(e) => guardarEstadoFormulario(e)} />
                        </Col>

                        <Col md={24}>
                            <span>{traducirPagina("Nombre_alternativo")}</span>

                            <br></br>
                            <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Msg_Nombre_alternativo")}</span>
                        </Col>

                        <Col md={24}>
                            <Input name="NOMBRE_ALTERNATIVO" autoComplete="off" value={payLoadLocal.NOMBRE_ALTERNATIVO} onChange={(e) => guardarEstadoFormulario(e)} />
                        </Col>

                        <Col md={24}>
                            <span>{traducirPagina("Observaciones")}</span>
                            <br></br>
                            <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Msg_Observaciones")}</span>
                        </Col>
                        <Col md={24}>
                            <Input.TextArea name="OBSERVACIONES" rows={10} value={payLoadLocal.OBSERVACIONES} onChange={(e) => guardarEstadoFormulario(e)} />
                        </Col>
                    </Row>
                </TabPane>

                <TabPane tab={traducirPagina("Imagen")} key="2" className="altura_container_licencias mt-2">
                    <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000' }} >
                        <Col md={24}>
                            <div className="containerFicheros" style={{ margin: '0px 0px 0px 1px' }}>
                                {ficheroLocal.IMAGEN_ORIGINAL === "" ?
                                    <>
                                        <label id="getFileLabel" htmlFor="getFile" style={{ fontSize: '26px',height:'640px',width:'-webkit-fill-available' }}><PlusOutlined ></PlusOutlined> {traducirPagina("Adjuntar")}</label>
                                        <input type="file" id="getFile" onChange={(e) => { gestionarFicheroLocal(e.target) }} />
                                    </>
                                    :

                                    <div className="containerFicheros_card" title={ficheroLocal.IMAGEN_NOMBRE}>
                                        <div className='containerFicheros_card_body' style={{height:'640px',width:'-webkit-fill-available' }}>

                                            <img src={`${ficheroLocal.IMAGEN_ORIGINAL}`} alt={ficheroLocal.IMAGEN_NOMBRE} />

                                            <div className="image-mask">
                                                <div className="image-mask-info" onClick={() => {
                                                    ficheroLocal.DATOS_IMAGEN = ""
                                                    ficheroLocal.IMAGEN_NOMBRE = ""
                                                    ficheroLocal.IMAGEN_ORIGINAL = ""
                                                    setFicherosLocal({ ...ficheroLocal })

                                                }}>
                                                    <label style={{ fontSize: '26px' }}><DeleteOutlined style={{ fontSize: '40px', display: 'block' }}></DeleteOutlined> {traducirPagina("Eliminar")}</label>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                }
                            </div>
                        </Col>
                    </Row>
                </TabPane>

                <TabPane tab={traducirPagina("Acciones")} key="3" className="altura_container_licencias mt-2">
                    <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000' }} >

                        <Col md={24} className="pt-2">
                            <span>{traducirPagina("Msg_evento_accion")}</span>
                        </Col>

                        <Col md={24} style={{ marginBottom: '10px' }}>
                            <Checkbox checked={filtroFechas.IR_ENLACE} onChange={(e) => {
                                filtroFechas.IR_ENLACE = !filtroFechas.IR_ENLACE
                                filtroFechas.ADJUNTAR_DOCUMENTO = false
                                filtroFechas.BUSCAR_REFERENCIA = false
                                setFiltroFechas({ ...filtroFechas });


                                payLoadLocal.TIPO_ACCION_CLICK = filtroFechas.IR_ENLACE ? 1 : 0;
                                setPayLoadLocal({ ...payLoadLocal })

                            }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Msg_ir_enlace")}</span> </Checkbox>
                        </Col>


                        <Col md={24} >
                            <Input disabled={!filtroFechas.IR_ENLACE} type="text" name="ENLACE" value={payLoadLocal.ENLACE} onChange={(e) => guardarEstadoFormulario(e)} ></Input>
                        </Col>

                        <Col md={24} style={{ marginBottom: '10px' }}>
                            <Checkbox checked={filtroFechas.BUSCAR_REFERENCIA} onChange={(e) => {
                                filtroFechas.BUSCAR_REFERENCIA = !filtroFechas.BUSCAR_REFERENCIA
                                filtroFechas.ADJUNTAR_DOCUMENTO = false
                                filtroFechas.IR_ENLACE = false
                                setFiltroFechas({ ...filtroFechas });

                                payLoadLocal.TIPO_ACCION_CLICK = filtroFechas.BUSCAR_REFERENCIA ? 2 : 0;
                                setPayLoadLocal({ ...payLoadLocal })
                            }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Msg_buscar_referencia")}</span> </Checkbox>
                        </Col>

                        <Col md={24} >
                            <Input disabled={!filtroFechas.BUSCAR_REFERENCIA} type="text" name="REFERENCIA" value={payLoadLocal.REFERENCIA} onChange={(e) => guardarEstadoFormulario(e)} ></Input>
                        </Col>



                        <Col md={24} style={{ marginBottom: '10px' }}>
                            <Checkbox checked={filtroFechas.ADJUNTAR_DOCUMENTO} onChange={(e) => {
                                filtroFechas.ADJUNTAR_DOCUMENTO = !filtroFechas.ADJUNTAR_DOCUMENTO
                                filtroFechas.IR_ENLACE = false
                                filtroFechas.BUSCAR_REFERENCIA = false
                                setFiltroFechas({ ...filtroFechas });

                                payLoadLocal.TIPO_ACCION_CLICK = filtroFechas.ADJUNTAR_DOCUMENTO ? 3 : 0;
                                setPayLoadLocal({ ...payLoadLocal })
                            }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Msg_descarga_documento")}</span> </Checkbox>
                        </Col>


                        <Col md={24}>

                            <div className="containerFicheros" style={{ opacity: filtroFechas.ADJUNTAR_DOCUMENTO ? '' : '0.5', pointerEvents: filtroFechas.ADJUNTAR_DOCUMENTO ? '' : 'none', margin: '0px 0px 0px 1px' }}>
                                {ficheroLocal.DOCUMENTO_ORIGINAL === "" ?
                                    <>
                                        <label id="getFileLabelDoc" htmlFor="getFileDoc" style={{ fontSize: '18px', height: '140px', width: "140px" }}><PlusOutlined style={{ fontSize: '18px' }}></PlusOutlined> {"Adjuntar"}</label>
                                        <input type="file" id="getFileDoc" onChange={(e) => { gestionarDocumentoLocal(e.target) }} />
                                    </>
                                    :
                                    <div className="containerFicheros_card" title={ficheroLocal.NOMBRE_DOCUMENTO}>
                                        <div className='containerFicheros_card_body' style={{ height: '140px', width: "140px" }}>

                                            <img src={"./imagenes/iconos/generico.png"} alt={ficheroLocal.NOMBRE_DOCUMENTO} style={{ width: '90px' }} />

                                            <div className="image-mask">
                                                <div className="image-mask-info">


                                                    <DeleteOutlined title='Visualizar' style={{ fontSize: '24px', display: 'inline-block', marginRight: '20px' }} onClick={() => {
                                                        ficheroLocal.DATOS_DOCUMENTO = ""
                                                        ficheroLocal.NOMBRE_DOCUMENTO = ""
                                                        ficheroLocal.DOCUMENTO_ORIGINAL = ""
                                                        setFicherosLocal({ ...ficheroLocal })
                                                    }}></DeleteOutlined>


                                                    <CloudDownloadOutlined title='Descargar' style={{ fontSize: '24px', display: 'inline-block' }} onClick={() => {
                                                        descargarDocPasandoBase64Doc(ficheroLocal.DOCUMENTO_ORIGINAL, ficheroLocal.NOMBRE_DOCUMENTO)

                                                    }}></CloudDownloadOutlined>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                        </Col>


                    </Row>
                </TabPane>

                <TabPane tab={traducirPagina("Programacion")} key="4" className="altura_container_licencias mt-2">
                    <Row gutter={[8, 8]} style={{ fontSize: '16px', fontWeight: '500', color: '#000' }} >

                        <Col md={24} className="pt-2">
                            <span style={{ fontSize: '18px', fontWeight: '600', }}>{`${traducirPagina("Campania_realizara")}: `} </span>

                            <br></br>
                            <span style={{ fontSize: '14px', fontWeight: 'normal', color: '#999' }}>{traducirPagina("Msg_Campania_realizara")}</span>
                        </Col>

                        <Col md={42} style={{ marginBottom: '10px' }} >

                            <Col md={8} style={{ marginBottom: '10px' }}>
                                <Checkbox checked={filtroFechas.FECHA} onChange={(e) => {
                                    filtroFechas.FECHA = true;
                                    filtroFechas.POR_DIA = false;
                                    filtroFechas.INTERVALO = false;

                                    setFiltroFechas({ ...filtroFechas });
                                }
                                }
                                ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Una_vez")}</span> </Checkbox>
                            </Col>

                            <Col md={16} style={{ marginBottom: '15px' }}>
                                <input disabled={!filtroFechas.FECHA} type="date" name="FECHA_UNICA" value={payLoadLocal.FECHA_UNICA} onChange={(e) => guardarEstadoFormulario(e)} style={{ width: '150px' }}></input>
                            </Col>

                            <Col md={8} style={{ marginBottom: '10px' }}>
                                <Checkbox checked={filtroFechas.POR_DIA} onChange={(e) => {
                                    filtroFechas.FECHA = false;
                                    filtroFechas.POR_DIA = true;
                                    filtroFechas.INTERVALO = false;
                                    setFiltroFechas({ ...filtroFechas });


                                }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("Cada")}</span> </Checkbox>
                            </Col>

                            <Col md={16} style={{ marginBottom: '20px' }}>
                                {DIA_REPETICION !== null ?
                                    <select disabled={!filtroFechas.POR_DIA} value={payLoadLocal.DIA_REPETICION} className="custom-select" name="DIA_REPETICION"
                                        style={{ width: '150px' }}
                                        onChange={(e) => { guardarEstadoFormulario(e) }}>
                                        {DIA_REPETICION.length > 0 ?
                                            DIA_REPETICION.map((dia) =>
                                                <option key={dia} value={dia}>{traducirPagina(diaPorNumero(dia)).toUpperCase()}</option>
                                            )
                                            :
                                            null
                                        }
                                    </select>
                                    :
                                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                        <h4>{traducirPagina("Info_error_idioma")}</h4>
                                    </div>
                                }
                            </Col>

                            <Col md={8} style={{ marginBottom: '10px' }}>
                                <Checkbox checked={filtroFechas.INTERVALO} onChange={(e) => {
                                    filtroFechas.FECHA = false;
                                    filtroFechas.POR_DIA = false;
                                    filtroFechas.INTERVALO = true;

                                    setFiltroFechas({ ...filtroFechas });


                                }} ><span style={{ fontSize: '16px', fontWeight: '500', color: '#000' }}>{traducirPagina("txt_intervalo")}</span> </Checkbox>
                            </Col>


                            <Col md={2} style={{ padding: "0px" }}>
                                <span style={{ verticalAlign: "sub" }}>{traducirPagina("Desde")} </span>
                            </Col>

                            <Col md={14} >
                                <input disabled={!filtroFechas.INTERVALO} type="date" name="DESDE" value={payLoadLocal.DESDE} onChange={(e) => guardarEstadoFormulario(e)} style={{ width: '150px' }}></input>
                            </Col>


                            <Col md={2} style={{ padding: "0px" }}>
                                <span style={{ verticalAlign: "sub" }}>{traducirPagina("Hasta")} </span>
                            </Col>

                            <Col md={14}>
                                <input disabled={!filtroFechas.INTERVALO} type="date" name="HASTA" value={payLoadLocal.HASTA} onChange={(e) => guardarEstadoFormulario(e)} style={{ width: '150px' }}></input>
                            </Col>

                        </Col>
                    </Row>
                </TabPane>
            </Tabs>



            <div className="container_guardar_cliente">
                <button
                className="btnShopData btnColores" 
                onClick={(e) => { guardarCambios() }}
                >
                    <SaveOutlined style={{ fontSize: '20px' }} /> <span>{traducirPagina("Guardar_salir").toUpperCase()} </span>
                      </button>
            </div>






        </Drawer>
    )

};




FichaMarketing.propTypes = {
    title: PropTypes.string,
    idDocumento: PropTypes.number,
    LICENCIAS: PropTypes.array,
    ESTADO_FICHA: PropTypes.bool,
    CERRAR_FICHA: PropTypes.func,
    ID_SOCIO: PropTypes.number,
    ID_USUARIO: PropTypes.number,
    ACTUALIZAR_REGLAS: PropTypes.func,
    TEXTO_BUSCADOR: PropTypes.func,
    SELECCIONADO: PropTypes.object,
    MODIFICAR_SELECCIONADO: PropTypes.func,
};

const mapStateToProps = (state, props) => {
    return {
        props: props,
        configApp: state.configApp,
        clienteTallerSeleccionado: state.clienteTallerSeleccionado,
        VehiculoTallerSeleccionado: state.VehiculoTallerSeleccionado,
        datosFacturacion: state.datosFacturacion
    };
}

export default connect(mapStateToProps)(FichaMarketing);